import { createSlice } from '@reduxjs/toolkit';

import { status } from 'utils/const';
import { thunks } from './thunks';
import { selectors } from './selectors';

const defaultValues = {
  role: { label: '', value: '' },
};

const initialState = {
  connections: [],
  userProfile: {},
  pagination: {
    current: 1,
  },
  filters: {
    fields: defaultValues,
    updatedFields: 0,
  },
  loadingConnectionsAccounts: status.IDLE,
  loadingProfile: status.IDLE,
  loadingUpdateProfile: status.IDLE,
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
    setFilters: (state, { payload }) => {
      let updatedFieldsCount = 0;
      const defaultValues = Object.values(initialState.filters.fields);

      Object.values(payload).forEach((field, index) => {
        if (field.label !== defaultValues[index].label) {
          updatedFieldsCount += 1;
        }
      });

      state.filters.updatedFields = updatedFieldsCount;
      state.filters.fields = payload;
    },
    setPage: (state, { payload }) => {
      state.pagination.current = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunks.getConnectedAccounts.pending, (state) => {
        state.loadingConnectionsAccounts = status.PENDING;
      })
      .addCase(thunks.getConnectedAccounts.fulfilled, (state, action) => {
        state.connections = action.payload.data.original.data;
        state.loadingConnectionsAccounts = status.SUCCESS;
      })
      .addCase(thunks.getConnectedAccounts.rejected, (state) => {
        state.loadingConnectionsAccounts = status.FAIL;
      })

      .addCase(thunks.getUserInfo.pending, (state) => {
        state.loadingProfile = status.PENDING;
      })
      .addCase(thunks.getUserInfo.fulfilled, (state, action) => {
        state.userProfile = action.payload.data;
        state.loadingProfile = status.SUCCESS;
      })
      .addCase(thunks.getUserInfo.rejected, (state) => {
        state.loadingProfile = status.FAIL;
      })

      .addCase(thunks.updateUserInfo.pending, (state) => {
        state.loadingUpdateProfile = status.PENDING;
      })
      .addCase(thunks.updateUserInfo.fulfilled, (state, action) => {
        state.userProfile = action.payload.data;
        state.loadingUpdateProfile = status.SUCCESS;
      })
      .addCase(thunks.updateUserInfo.rejected, (state) => {
        state.loadingUpdateProfile = status.FAIL;
      });
  },
});

const profile = {
  actions: slice.actions,
  thunks,
  selectors,
};

export { profile };
export default slice.reducer;
